import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/lightbulb.vue
var s = {
	name: "DtIconLightbulb",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--lightbulb"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Lightbulb",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M3.525 1.525A3.5 3.5 0 0 1 9.5 3.996a2.825 2.825 0 0 1-.903 2.115c-.325.326-.493.617-.56.98a.5.5 0 1 1-.984-.181c.113-.615.413-1.082.844-1.513A1.825 1.825 0 0 0 8.5 4.009V4a2.5 2.5 0 1 0-5 0c0 .398.081.872.596 1.39.435.401.732.931.849 1.513a.5.5 0 0 1-.981.195 1.805 1.805 0 0 0-.568-.994C2.647 5.354 2.5 4.6 2.5 4a3.5 3.5 0 0 1 1.025-2.475ZM4 9a.5.5 0 0 1 .5-.5h3a.5.5 0 1 1 0 1h-3A.5.5 0 0 1 4 9Zm.5 2a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1H5a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=lightbulb.js.map